import {
  SET_CAMPS_PROPERTY,
  CAMPS_ERROR,
  CAMPS_CARS_RESET_FILTERS,
  CAMPS_TASKS_LIST_RESET_FILTERS,
  CAMPS_UPDATE_MASTER_DATA,
  CAMPS_TASKS_RESET_FILTERS,
  CAMPS_UPDATE_TASK_STATE,
  CAMPS_PAPS_LIST_RESET_FILTERS,
  CAMPS_UPDATE_EXT_ACCESSORIES,
  CAMPS_UPDATE_INT_ACCESSORIES,
  CAMPS_UPDATE_INT_DAMAGES,
  CAMPS_UPDATE_EXT_DAMAGES,
  CAMPS_RESET_MANAGERS_TRANSPORT_LIST_FILTERS,
  CAMPS_RESET_EMPLOYEES_TRANSPORT_LIST_FILTERS,
  CAMPS_RESET_TIRES
} from 'store/actions/camps';
import { setValueObjectByField, mapOptionsMasterData } from 'helpers/object';

export default {
  [SET_CAMPS_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [CAMPS_UPDATE_MASTER_DATA]: (state, data) => {
    const propertiesToMap = [
      'storageParks',
      'states',
      'subStates',
      'categories',
      'taskStatus',
      'taskTypes',
      'papStatus',
      'papFieldStatus',
      'papAccessoryStatus',
      'wheels',
      'cleaning',
      'transportStatus',
      'transportTypes',
      'transportProviders',
      'brandTires',
      'spareWheels'
    ];
    propertiesToMap.forEach(prop => {
      state[prop] = data[prop] ? mapOptionsMasterData(data[prop]) : [];
    });
  },

  [CAMPS_ERROR]: (state, error) => {
    state.error = error;
  },

  [CAMPS_CARS_RESET_FILTERS]: (state, { loginPartners }) => {
    state.carListFilters = {
      plate: '',
      startDate: '',
      endDate: '',
      idStoragePark: loginPartners ? state.carListFilters.idStoragePark : '',
      idState: '',
      idCategory: ''
    };
    state.filtersHasChanged = false;
  },

  [CAMPS_TASKS_LIST_RESET_FILTERS]: (state, { loginPartners }) => {
    state.taskListFilter = {
      plate: '',
      startDate: '',
      endDate: '',
      idStoragePark: loginPartners ? state.taskListFilter.idStoragePark : '',
      idTaskStatus: '',
      idTaskTypes: '',
      idPap: ''
    };
    state.filtersHasChanged = false;
  },

  [CAMPS_TASKS_RESET_FILTERS]: state => {
    state.taskFilter = {
      idTaskTypes: '',
      idTaskStatus: '',
      startDate: '',
      endDate: ''
    };
    state.filtersHasChanged = false;
  },

  [CAMPS_UPDATE_TASK_STATE]: (state, { idTask, idTaskStatus }) => {
    const task = state.taskList?.find(t => t.idTask.toString() === idTask.toString());
    if (task) {
      task.idTaskStatus = idTaskStatus;
    }
  },

  [CAMPS_PAPS_LIST_RESET_FILTERS]: state => {
    state.papsFilter = {
      ...state.papsFilter,
      idStoragePark: state.taskListFilter.idStoragePark,
      idState: '',
      plate: ''
    };
    state.filtersHasChanged = false;
  },

  [CAMPS_RESET_EMPLOYEES_TRANSPORT_LIST_FILTERS]: state => {
    state.transportEmployeesListFilters = {
      idStoragePark: '',
      idProvider: '',
      idType: '',
      idState: '',
      plate: ''
    };
    state.filtersHasChanged = false;
  },

  [CAMPS_RESET_MANAGERS_TRANSPORT_LIST_FILTERS]: state => {
    state.transportManagerListFilters = {
      idProvider: '',
      idType: '',
      idState: '',
      plate: ''
    };
    state.filtersHasChanged = false;
  },

  [CAMPS_UPDATE_EXT_ACCESSORIES]: (state, { idAccessory, stateValue }) => {
    const index = state.papDetail.accesoriesCar.findIndex(
      accessory => accessory.idAccesory === idAccessory
    );
    if (index !== -1) {
      state.papDetail.accesoriesCar[index].idState = stateValue;
    }
  },

  [CAMPS_UPDATE_INT_ACCESSORIES]: (state, { idAccessory, stateValue }) => {
    const index = state.papDetail.intAccesoriesCar.findIndex(
      accessory => accessory.idAccesory === idAccessory
    );
    if (index !== -1) {
      state.papDetail.intAccesoriesCar[index].idState = stateValue;
    }
  },

  [CAMPS_UPDATE_INT_DAMAGES]: (state, { codDamage, isDamaged }) => {
    const index = state.papDetail.intDamagesCar.findIndex(damage => damage.codDamage === codDamage);
    if (index !== -1) {
      state.papDetail.intDamagesCar[index].isDamaged = isDamaged;
    }
  },

  [CAMPS_UPDATE_EXT_DAMAGES]: (state, { codDamage, isDamaged }) => {
    const index = state.papDetail.damagesCar.findIndex(damage => damage.codDamage === codDamage);
    if (index !== -1) {
      state.papDetail.damagesCar[index].isDamaged = isDamaged;
    }
  },

  [CAMPS_RESET_TIRES]: (state, { field, value, reset }) => {
    reset.forEach(fieldReset => {
      setValueObjectByField(state, `papDetail.${fieldReset}`, null);
    });
    setValueObjectByField(state, field, value);
  }
};
